import * as api from './index';

export function getClients(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/clients?${queryString}`);
}

export function getClient(id) {
    return api.get(`/clients/${id}`);
}

export function createClient(client) {
    return api.post('/clients', client);
}

export function updateClient(client) {
    return api.patch(`/clients/${client.id}`, client);
}

export function setIsActiveClient(client, isActive) {
    return api.patch(`/clients/${client.id}/isActive`, { isActive });
}

export function softDeleteClient(client) {
    return api.del(`/clients/${client.id}/soft`);
}
